@if (!disableTranslation) {
<span>{{ text | flTranslate }}</span>
} @else {
<span>{{ text }}</span>
}
